import React, { useContext, useEffect, useRef, useState } from 'react';
import Application from '../../../StateContext/Application';
import { Cancel32, DeleteRed32, EditBlueBlue32, submit } from '../../../../../public/LoginImages/importimages';
const AddProduct = () => {
    const statecalls = useContext(Application);
    const { AddProduct, getBindata } = statecalls;

    const [data, setData] = useState([]);
    const [Bin, setBin] = useState([]);
    const formdataRef = useRef(null)

    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 6;
    const totalPages = Math.ceil(data.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = data.slice(indexOfFirstBill, indexOfLastBill);


    const [formData, setFormData] = useState({
        ProductName: '',
        PartCode: '',
        BinNumbers: '',
        Size: '',
        MinStockLevel: '',
        MaxStockLevel: '',
        UOM: '',
    });
    const [editId, setEditId] = useState(null);

    const getAllData = async () => {
        const response = await AddProduct("get");
        if (response && Array.isArray(response)) {
            setData(response);
            console.log("Set data:", response);
        } else {
            setData([]);
        }
    };
    const getBin = async () => {
        let data = await getBindata();
        console.log("Fetched Bin Data:", data);
        if (Array.isArray(data)) {
            setBin(data);
        } else if (data?.data && Array.isArray(data.data)) {
            setBin(data.data);
        } else {
            console.warn("Unexpected format from getBindata:", data);
            setBin([]);
        }
    };

    useEffect(() => {
        getAllData();
        getBin();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const Submit = async (e) => {
        e.preventDefault();
        console.log("Form submitted", formData);

        if (editId) {
            const response = await AddProduct("update", { ID: editId, ...formData });
            console.log("Update response:", response);
            if (response?.message === "success") {
                alert("Product updated successfully");
                getAllData();
                setFormData({
                    ProductName: '',
                    PartCode: '',
                    BinNumbers: '',
                    Size: '',
                    MinStockLevel: '',
                    MaxStockLevel: '',
                    UOM: '',
                });
                setEditId(null);
            }
        } else {
            const response = await AddProduct("insert", formData);
            console.log("Insert response:", response);
            if (response?.message === "success") {
                alert("Product added successfully", { className: 'custom-alert' });
                getAllData();
                setFormData({
                    ProductName: '',
                    PartCode: '',
                    BinNumbers: '',
                    Size: '',
                    MinStockLevel: '',
                    MaxStockLevel: '',
                    UOM: '',
                });
            }
        }
    };

    const handleEdit = (item) => {
        setFormData({
            ProductName: item.Product_Name,
            PartCode: item.Part_Code,
            BinNumbers: item.Bin_Location,
            Size: item.Size,
            MinStockLevel: item.Min_Stock_Level,
            MaxStockLevel: item.Max_Stock_Level,
            UOM: item.UOM,
        });
        setEditId(item.ID);
        console.log("edit id", item.ID);
    };
    const handleDelete = async (e, ID) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete?")) {
            const response = await AddProduct("delete", { ID });
            if (response?.message === "success") {
                getAllData();
            }
        }
    };
    const resetdata = () => {
        formdataRef.current.reset();
        setFormData({
            PropertyNumber: "",
            PropertyLocation: "",
            GMapLink: "",
            DepartmentName: "",
            PropertyArea: "",
            Auction_Reserver_Price: "",
            AuctionFor: "",
            Node: "",
            Scheme: "",
            SectorNo: "",
            PlotNo: "",
            AuctionBasePrice: "",
            Use: "",
            FSI: "",
            Auction_Type: "",
            AfterSalesOtherCharges: "",
            DocumentDownloadStartDateTime: "",
            DocumentEndDateTime: "",
            TenderOpeningDateTime: '',
            TenderLastDateTime: '',
            AuctionStartDateTime: "",
            AuctionEndDateTime: "",
            PaymentStartDateTime: "",
            PaymentEndDateTime: '',
        });
        getAllData([]);
    }

    return (
        <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4f7fe', overflowY: 'auto', maxHeight: '91vh', padding: '0px 0px 20px 0px' }}>
            <div style={{ backgroundColor: '#f4f7fe', backgroundSize: 'cover', width: '81vw', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem', position: "relative", backdropFilter: 'blur(10px)', overflowY: 'auto' }}>

                <div style={{ display: "grid", justifyContent: "center" }}>
                    <div className="card-body my-3" style={{ width: "75vw" }}>
                        <form onSubmit={Submit} ref={formdataRef} style={{ backgroundColor: 'rgb(255,255,255,0.8)', borderRadius: '20px' }}>

                            <div style={{ display: 'grid', justifyContent: 'center', padding: '2rem' }}>
                                <h5 className='mx-3' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', padding: '10px' }}><img src='' />{editId ? "Edit Product" : "Add Product"}</h5>
                                <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Product Name</label>
                                            <input type="text" className="form-control" name="ProductName" value={formData.ProductName} onChange={handleChange} placeholder="Enter Product Name Here" required />

                                        </div>
                                        <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                            <label className="form-label" style={{ fontWeight: '700', width: '11rem' }}>Part Code</label>
                                            <input type="text" name="PartCode" value={formData.PartCode} onChange={handleChange} className="form-control" placeholder="Enter Part Code Here" required />
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                            <label className="form-label" style={{ fontWeight: '700', width: '11rem' }}>Bin Location</label>
                                            <select
                                                style={{ boxShadow: '0px 0px 4px' }}
                                                className="form-select"
                                                aria-label="Default select example"
                                                name="BinNumbers"
                                                value={formData.BinNumbers}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select Bin Series</option>
                                                {Array.isArray(Bin) && Bin.map((item, index) => (
                                                    <option key={index} value={item.series}>
                                                        {item.series}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Size</label>
                                            <input type="text" className="form-control" placeholder='Enter size here' name="Size" value={formData.Size} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Min Stock Level</label>
                                            <input type="number" className="form-control" placeholder='Enter min stock Level here' name="MinStockLevel" value={formData.MinStockLevel} onChange={handleChange} required />
                                        </div>
                                        <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Max Stock Level</label>
                                            <input type="number" className="form-control" placeholder='Enter max Stock level here' name="MaxStockLevel" value={formData.MaxStockLevel} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                                        <label className='form-label'>UOM</label>
                                        <select name="UOM" value={formData.UOM} onChange={handleChange} className="form-select" style={{ boxShadow: '0px 0px 4px' }}>
                                            <option disabled value="">Select UOM</option>
                                            <option value="Kg">Kgs</option>
                                            <option value="Ton">Bdle</option>
                                            <option value="Litre">Ltr</option>
                                            <option value="Piece">Nos</option>
                                            <option value="Meter">Set</option>
                                            <option value="Pack">Roll</option>
                                            <option value="Pkt">Pkt</option>
                                            <option value="Kit">Kit</option>
                                        </select>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', paddingTop: '10px' }}>
                                        <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>{editId ? (<img src='' style={{ width: "1.2rem", paddingBottom: "3px" }} />) : (<img src={submit} alt="Submit" style={{ width: "1.2rem", paddingBottom: "3px" }} />)}{editId ? "Update" : "Submit"} </button>
                                        <button onClick={resetdata} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#E63E23', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} /> Cancel</button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
                <div style={{ display: 'grid', justifyContent: 'center', width: '75vw', borderRadius: '20px', backgroundColor: 'white', padding: '2rem', }}>
                    <h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Add Product List</h5>
                    <div style={{ display: 'flex', justifyContent: 'center', width: '70vw', backgroundColor: '#e8f7f3', border: '1px solid darkgray' }}>
                        <table style={{ backgroundColor: '#e8f7f3', width: '100%' }}>
                            <thead>
                                <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                                    <th>Sr.No</th>
                                    <th>Product Name</th>
                                    <th>Part Code</th>
                                    <th>Bin Numbers</th>
                                    <th>Size</th>
                                    <th>Min Stock Level</th>
                                    <th>Max Stock Level</th>
                                    <th>UOM</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentBills?.map((item, index) => (
                                    <tr key={item.ID || index}>
                                        <td>{index + 1}</td>
                                        <td>{item.Product_Name}</td>
                                        <td>{item.Part_Code}</td>
                                        <td>{item.Bin_Location}</td>
                                        <td>{item.Size}</td>
                                        <td>{item.Min_Stock_Level}</td>
                                        <td>{item.Max_Stock_Level}</td>
                                        <td>{item.UOM}</td>
                                        <td style={{ padding: '5px' }}>
                                            <button onClick={() => handleEdit(item)} className="btn btn-custom-edit" style={{ width: '5rem', border: '1px solid #502eff', backgroundColor: 'white', borderRadius: '5px', padding: '5px', fontSize: '14px', color: '#502eff', fontWeight: '700' }}><img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> Edit</button>
                                            <button onClick={(e) => handleDelete(e, item.ID)} className="btn btn-custom-delete" style={{ width: '6rem', border: '1px solid #ee5d50', backgroundColor: 'white', borderRadius: '5px', padding: '5px', marginLeft: '10px', color: '#ee5d50', fontSize: '14px', fontWeight: '700' }}><img className="icon-delete"
                                                src={DeleteRed32}
                                                style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
                                            /> Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 5rem', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p style={{ margin: '0px', color: 'black' }}>
                        Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, data.length)} of {data.length} entries
                    </p>

                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
    );
};

export default AddProduct;
